/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FilterComponentType } from '../../types';
import RadioButtonGroup from '../../../../shared/design-system/components/radio-button-group';

interface RadioFilterProps {
  filterKey: string;
  name: string;
  handleQuery: (params: {
    filterKey: string;
    filterValue: number | string | null;
    filterType: string;
  }) => void;
  hideLabel?: boolean;
  className?: string;
  pendingFilters?: URLSearchParams;
  customOptions?: Array<{ label: string; value: string | number }>;
}

const RadioFilter: React.FC<RadioFilterProps> = ({
  filterKey,
  name,
  handleQuery,
  hideLabel = false,
  className = '',
  pendingFilters,
  customOptions,
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [selectedValue, setSelectedValue] = useState<
    number | string | null
  >(null);

  useEffect(() => {
    // Check pendingFilters first (if available), otherwise use URL params
    const paramsToRead = pendingFilters || queryParams;
    const paramValue = paramsToRead.get(filterKey);
    if (customOptions) {
      // For custom options, use string values
      setSelectedValue(paramValue || null);
    } else {
      // For Yes/No options, use numeric values
      if (paramValue === '1') {
        setSelectedValue(1);
      } else if (paramValue === '0') {
        setSelectedValue(0);
      } else {
        setSelectedValue(null);
      }
    }
    // eslint-disable-next-line no-restricted-globals
  }, [location?.search, filterKey, pendingFilters, customOptions]);

  const handleChange = (value: number | string) => {
    // Allow deselection by clicking the same option again
    const newValue = value === selectedValue ? null : value;
    setSelectedValue(newValue);
    handleQuery({
      filterKey,
      filterValue: newValue,
      filterType: FilterComponentType.RADIO_BUTTON,
    });
  };

  const options = customOptions || [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
  ];

  return (
    <div className={`radio-filter-container ${className}`}>
      {!hideLabel && (
        <p className="radio-filter-label blue-txt-15 mb-2">{name}</p>
      )}
      <div className="radio-filter-options">
        <RadioButtonGroup
          name={filterKey}
          options={options.map((opt) => ({
            label: opt.label,
            value: typeof opt.value === 'string' ? opt.value : opt.value,
          }))}
          value={selectedValue}
          onChange={handleChange}
          variant={RadioButtonGroup.Variant.Default}
        />
      </div>
    </div>
  );
};

export default RadioFilter;
